import { Circle1, Circle2, Circle3, LoaderCircles, LoaderWrapper } from './styles';
import { CSSProperties } from 'styled-components';

type LoaderType = {
  size?: 'large' | 'medium' | 'small';
  width?: number | string;
  backgroundColor?: CSSProperties['backgroundColor'];
  inline?: boolean;
  mobileStretch?: boolean;
};

export const Loader = ({ size = 'large', width, backgroundColor, inline, mobileStretch }: LoaderType) => {
  return (
    <LoaderWrapper
      size={size}
      width={width}
      backgroundColor={backgroundColor}
      inline={inline}
      mobileStretch={mobileStretch}
    >
      <LoaderCircles>
        <Circle1 />
        <Circle2 />
        <Circle3 />
      </LoaderCircles>
    </LoaderWrapper>
  );
};
